export default class formConfig {
  // 国家代码-详情
  static configList() {
    return [
      {
        title: "国家及行政区划",
        name: "1",
        icon: "",
        tip: "（世界各国和地区名称代码详情）",
        formConfigList: [
          {
            label: "中文简称：",
            type: "input",
            value: "chineseName",
            placeholder: "请输入",
            maxlength: 100,
            rule: {
              required: true,
              message: "请填写中文简称",
              trigger: "blur"
            }
          },
          {
            label: "英文简称：",
            type: "input",
            value: "englishName",
            placeholder: "请输入",
            maxlength: 300,
            rule: {
              required: true,
              message: "请填写英文简称",
              trigger: "blur"
            }
          },
          {
            label: "两字符代码：",
            type: "input",
            value: "twoCharCode",
            placeholder: "请输入",
            maxlength: 2,
            rule: {
              required: true,
              message: "请填写两字符代码",
              trigger: "blur"
            }
          },
          {
            label: "三字符代码：",
            type: "input",
            value: "threeCharCode",
            placeholder: "请输入",
            maxlength: 3,
            rule: {
              required: true,
              message: "请填写三字符代码",
              trigger: "blur"
            }
          },
          {
            label: "数字代码：",
            type: "input",
            value: "numberCode",
            placeholder: "请输入",
            maxlength: 10,
            rule: {
              required: true,
              message: "请填写数字代码",
              trigger: "blur"
            }
          },
        ]
      },
    ];
  }
  // 行政区划-详情
  static administrativeArea() {
    return [
      {
        title: "国家及行政区划",
        name: "1",
        icon: "",
        tip: "（行政区域代码划分详情）",
        formConfigList: [
          {
            label: "上级行政区域：",
            type: "slot",
            slotName: "parentAreaName",
            value: "parentAreaName",
            placeholder: "请输入",
            rule: {
              required: false,
              message: "请填写上级行政区域",
              trigger: "blur"
            }
          },
          {
            label: "行政区域代码：",
            type: "input",
            value: "areaCode",
            placeholder: "请输入",
            maxlength: 30,
            rule: {
              required: true,
              message: "请填写行政区域代码",
              trigger: "blur"
            }
          },
          {
            label: "行政区域名称：",
            type: "input",
            value: "areaName",
            placeholder: "请输入",
            maxlength: 150,
            rule: {
              required: true,
              message: "请填写行政区域名称",
              trigger: "blur"
            }
          },
          {
            label: "行政级别：",
            type: "select",
            value: "levelNum",
            placeholder: "请输入",
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201507041522510003"
            },
            rule: {
              required: true,
              message: "请选择行政级别",
              trigger: "blur"
            }
          },
        ]
      },
    ];
  }
}
